import { useEffect, useState } from "react";
import { adminApi } from "../../api/adminApi";
import type { EmailConfigDto } from "../../api/types";
import { EmailConfigForm } from "../../components/EmailConfigForm";

export default function EmailConfig() {
  const [config, setConfig] = useState<EmailConfigDto | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  function load() {
    setLoading(true);
    adminApi.emailConfig
      .get()
      .then(setConfig)
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load email config"))
      .finally(() => setLoading(false));
  }

  useEffect(load, []);

  return (
    <div>
      <div className="page-header">
        <h1>Email</h1>
      </div>
      {error && <div className="error-text">{error}</div>}

      <div className="page-panel">
        <h3>SMTP configuration</h3>
        <EmailConfigForm
          config={config}
          loading={loading}
          fallbackNotice="No custom email configuration set for this tenant yet — the platform default is used until you save one here."
          onSave={async (body) => {
            const saved = await adminApi.emailConfig.save(body);
            setConfig(saved);
          }}
          onTest={(to) => adminApi.emailConfig.test(to)}
        />
      </div>
    </div>
  );
}
